/* /assets/wishlist.js
   Custom wishlist: localStorage-backed, no accounts, no app.
   Loaded only when settings.wishlist_enable is true (see layout/theme.liquid). */

(function () {
  'use strict'

  var STORAGE_KEY = 'ondro-wishlist'
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'

  function getConfig () {
    var node = document.querySelector('[data-wishlist-config]')
    if (!node) return {}

    try {
      return JSON.parse(node.textContent)
    } catch (error) {
      return {}
    }
  }

  var config = getConfig()

  function readList () {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY)
      var list = raw ? JSON.parse(raw) : []
      return Array.isArray(list) ? list : []
    } catch (error) {
      return []
    }
  }

  function writeList (list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
      return true
    } catch (error) {
      return false
    }
  }

  function isWishlisted (handle) {
    return readList().indexOf(handle) !== -1
  }

  function toggleHandle (handle) {
    var list = readList()
    var position = list.indexOf(handle)
    var added = false

    if (position === -1) {
      list.push(handle)
      added = true
    } else {
      list.splice(position, 1)
    }

    writeList(list)

    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        bubbles: true,
        detail: { handles: list, handle: handle, added: added },
      })
    )

    return added
  }

  function syncButton (button) {
    var handle = button.dataset.wishlistHandle
    if (!handle) return

    var active = isWishlisted(handle)

    button.classList.toggle('is-active', active)
    button.setAttribute('aria-pressed', active ? 'true' : 'false')

    if (active && config.labelRemove) {
      button.setAttribute('aria-label', config.labelRemove)
    } else if (!active && config.labelAdd) {
      button.setAttribute('aria-label', config.labelAdd)
    }
  }

  function syncAllButtons (root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document
    scope.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton)
  }

  function pushKlaviyo (eventName, button) {
    if (!eventName || !config.klaviyoEnable || !window.klaviyo || !button) return

    var d = button.dataset
    var image = d.productImage || ''
    if (image.indexOf('//') === 0) image = 'https:' + image

    window.klaviyo.push([
      'track',
      eventName,
      {
        ProductName: d.wishlistTitle || null,
        ProductID: d.wishlistId ? Number(d.wishlistId) : null,
        SKU: d.wishlistSku || null,
        Price: d.wishlistPrice ? parseFloat(d.wishlistPrice) : null,
        ProductURL: d.wishlistUrl ? (config.shopUrl || window.location.origin) + d.wishlistUrl : null,
        ImageURL: image || null,
        Vendor: d.wishlistVendor || null,
        ProductType: d.wishlistType || null,
        Categories: d.wishlistCollections ? d.wishlistCollections.split('|') : []
      }
    ])
  }

  function handleDocumentClick (event) {
    var button = event.target.closest && event.target.closest('[data-wishlist-toggle]')
    if (!button) return

    event.preventDefault()

    var handle = button.dataset.wishlistHandle
    if (!handle) return

    var added = toggleHandle(handle)
    syncAllButtons(document)
    pushKlaviyo(added ? config.klaviyoEventAdd : config.klaviyoEventRemove, button)
  }

  document.addEventListener('click', handleDocumentClick)
  document.addEventListener('theme:product:added', function () { syncAllButtons(document) })
  document.addEventListener('theme:quick-add:open', function () { syncAllButtons(document) })
  document.addEventListener('shopify:section:load', function (event) { syncAllButtons(event.target) })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAllButtons(document) })
  } else {
    syncAllButtons(document)
  }

  class WishlistCountElement extends HTMLElement {
    constructor () {
      super()
      this.onUpdate = this.onUpdate.bind(this)
    }

    connectedCallback () {
      document.addEventListener('wishlist:updated', this.onUpdate)
      this.update(readList().length)
    }

    disconnectedCallback () {
      document.removeEventListener('wishlist:updated', this.onUpdate)
    }

    onUpdate (event) {
      this.update(event.detail.handles.length)
    }

    update (count) {
      this.setAttribute('data-wishlist-count', count)

      var text = count
      var limit = parseInt(this.dataset.limit, 10)
      if (limit && count >= limit) text = limit + '+'

      this.textContent = text
    }
  }

  if (!customElements.get('wishlist-count')) {
    customElements.define('wishlist-count', WishlistCountElement)
  }

  class WishlistPageElement extends HTMLElement {
    connectedCallback () {
      this.target = 'api-product-grid-item'
      this.cache = {}
      this.grid = this.querySelector('[data-wishlist-grid]')
      this.emptyState = this.querySelector('[data-wishlist-empty]')
      this.sharedNotice = this.querySelector('[data-wishlist-shared-notice]')
      this.shareHolder = this.querySelector('[data-wishlist-share]')
      this.shareUrlInput = this.querySelector('[data-wishlist-share-url]')
      this.shareCopyButton = this.querySelector('[data-wishlist-share-copy]')

      var searchParams = new URLSearchParams(window.location.search)
      var sharedHandles = searchParams.get('h')
        ? searchParams.get('h').split(',').filter(Boolean)
        : searchParams.getAll('handle')
      this.isSharedView = sharedHandles.length > 0

      if (this.isSharedView && this.sharedNotice) this.sharedNotice.removeAttribute('hidden')

      // Share always reads the viewer's own list, never the shared link's handles.
      this.initShare()
      this.updateShareVisibility(readList().length > 0)

      this.onWishlistUpdated = this.onWishlistUpdated.bind(this)
      document.addEventListener('wishlist:updated', this.onWishlistUpdated)

      this.refreshShareUrl()
      this.render(this.isSharedView ? sharedHandles : readList())
    }

    disconnectedCallback () {
      if (this.onWishlistUpdated) {
        document.removeEventListener('wishlist:updated', this.onWishlistUpdated)
      }
    }

    buildShareUrl () {
      var handles = readList()
      return (config.shopUrl || window.location.origin) + (config.pageUrl || '/pages/wishlist') + '?h=' + handles.map(encodeURIComponent).join(',')
    }

    refreshShareUrl () {
      if (this.shareUrlInput) this.shareUrlInput.value = readList().length ? this.buildShareUrl() : ''
    }

    onWishlistUpdated (event) {
      this.updateShareVisibility(event.detail.handles.length > 0)
      this.refreshShareUrl()

      if (!this.isSharedView) this.render(event.detail.handles)
    }

    render (handles) {
      var self = this
      var token = this.renderToken = (this.renderToken || 0) + 1

      if (!handles.length) {
        if (this.grid) this.grid.innerHTML = ''
        if (this.emptyState) this.emptyState.removeAttribute('hidden')
        this.classList.remove('is-loading')
        return
      }

      if (this.emptyState) this.emptyState.setAttribute('hidden', '')
      this.classList.add('is-loading')

      var minDelay = new Promise(function (resolve) { window.setTimeout(resolve, 300) })
      var cards = Promise.all(handles.map(function (handle) { return self.fetchCard(handle) }))

      Promise.all([cards, minDelay]).then(function (results) {
        if (token !== self.renderToken || !self.grid) return
        self.grid.innerHTML = results[0].join('')
        syncAllButtons(self)
        self.classList.remove('is-loading')
      })
    }

    fetchCard (handle) {
      var self = this
      if (this.cache[handle]) return Promise.resolve(this.cache[handle])

      return fetch(ROOT + 'products/' + handle + '?section_id=' + this.target)
        .then(function (response) { return response.text() })
        .then(function (responseText) {
          var html = responseText.split('||itemAnimationDelay||').join('0').split('||itemAnimationAnchor||').join('')
          var fresh = document.createElement('div')
          fresh.innerHTML = html
          var content = fresh.querySelector('[data-api-content]')
          var markup = content ? content.innerHTML : ''
          if (markup) self.cache[handle] = markup
          return markup
        })
        .catch(function () { return '' })
    }

    updateShareVisibility (hasItems) {
      if (!this.shareHolder) return

      if (hasItems) {
        this.shareHolder.removeAttribute('hidden')
      } else {
        this.shareHolder.setAttribute('hidden', '')
      }
    }

    initShare () {
      if (!this.shareCopyButton) return

      var self = this

      this.shareCopyButton.addEventListener('click', function () {
        if (!readList().length) return
        var url = self.buildShareUrl()
        if (self.shareUrlInput) self.shareUrlInput.value = url

        var onCopied = function () {
          if (!self.shareCopyButton || self.copyTimer) return
          var original = self.shareCopyButton.textContent
          self.shareCopyButton.textContent = self.shareCopyButton.dataset.copiedText || 'Copied!'
          self.copyTimer = window.setTimeout(function () {
            if (self.shareCopyButton) self.shareCopyButton.textContent = original
            self.copyTimer = null
          }, 2000)
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(onCopied).catch(function () {
            self.fallbackSelect()
          })
        } else {
          self.fallbackSelect()
        }
      })
    }

    fallbackSelect () {
      if (!this.shareUrlInput) return
      this.shareUrlInput.removeAttribute('readonly')
      this.shareUrlInput.focus()
      this.shareUrlInput.select()
      this.shareUrlInput.setAttribute('readonly', 'readonly')
    }
  }

  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', WishlistPageElement)
  }
})()